import { Box, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker} from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

function PageOne() {
  const { t } = useTranslate();
  

  const relationshipOptions = [
    { value: "1", label: "Birinci Dereceden Akraba" },
    { value: "2", label: "İkinci Dereceden Akraba" },
    { value: "3", label: "Üçüncü Dereceden Akraba" },
    { value: "4", label: "Diğer Akrabalar" },
    { value: "5", label: "Arkadaş" },
    { value: "6", label: "Komşu" },
    { value: "7", label: "Diğer", color: 'red' }
  ];

  const personStatusOptions = [
    { value: "1", label: "Acil Durumda Aranılacak" },
    { value: "2", label: "Bilgi Veren" },
    { value: "3", label: "Bilgi Veren ve Acil Durumda Aranılacak" }
  ];

  const educationOptions = [
    { value: "1", label: "Okur Yazar Olmayan" },
    { value: "2", label: "Okur Yazar" },
    { value: "3", label: "İlköğretim" },
    { value: "4", label: "Lise" },
    { value: "5", label: "Ön Lisans" },
    { value: "6", label: "Lisans" },
    { value: "7", label: "Yüksek Lisans" },
    { value: "8", label: "Doktora" }
  ];

  const motherHabitsOptions = [
    { value: "1", label: "Alkol" },
    { value: "2", label: "Madde" },
    { value: "3", label: "Sigara" }
  ];

  const referralLocationOptions = [
    { value: "1", label: "Ev" },
    { value: "2", label: "Poliklinik" },
    { value: "3", label: "Acil" },
    { value: "4", label: "Doğumhane/Ameliyathane" },
    { value: "5", label: "Başka bir kurum" },
    { value: "6", label: "Diğer" }
  ];

  const arrivalMethodOptions = [
    { value: "1", label: "Kucakta" },
    { value: "2", label: "Transport Küvöz" },
    { value: "3", label: "Diğer" }
  ];

  const pregnancyTypeOptions = [
    { value: "1", label: "Spottan" },
    { value: "2", label: "İnseminasyon" },
    { value: "3", label: "Mikroenjeksiyon" },
    { value: "4", label: "Donör Anne" }
  ];

  const admissionPracticesOptions = [
    { value: "1", label: "Entübasyon" },
    { value: "2", label: "CRAP" },
    { value: "3", label: "Küvöz İçi Oksijen" },
    { value: "4", label: "Hood" },
    { value: "5", label: "Diğer" }
  ];

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2} sx={{ padding: "0px" }}>
          <Grid
            md={12}
            xs={12}
            container
            direction={"row"}
            spacing={3}
            sx={{ padding: "0px", margin: "0px" }}
          >
            <Grid
              md={4}
              xs={12}
              spacing={2}
              sx={{ padding: "0px", paddingRight: "20px" }}
            >
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: "4px",
                  p: 2,
                  height: "100%",
                }}
              >
                <Grid
                  sx={{
                    backgroundColor: "#63B4FF33",
                    color: "#2979C3",
                    borderRadius: "10px",
                  }}
                >
                  <ByzMuiTypography
                    isTitle
                    paddingRight={"20px"}
                    paddingTop={"5px"}
                  >
                    {t("newborn-patient-assessment.form-creation-info")}
                  </ByzMuiTypography>
                </Grid>

                <Grid sx={{ paddingTop: "20px" }}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("datetime")}
                  >
                    <ByzMuiDateTimePicker
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                      value={new Date()}
                    />
                  </ByzTitleAndInputBox>
                  <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "10px" }}
                    title={t("createdby")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={[]}
                      label="label"
                      placeholder={t("open-process-menu.select")}
                      sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                      multiple = {false}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Box>
            </Grid>

            <Grid md={8} xs={12} spacing={2} sx={{ padding: "0px" }}>
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: "4px",
                  padding: "20px",
                  height: "100%",
                }}
              >
                <Grid
                  sx={{
                    backgroundColor: "#63B4FF33",
                    color: "#2979C3",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <ByzMuiTypography
                    isTitle
                    paddingRight={"20px"}
                    paddingTop={"5px"}
                  >
                    {t("newborn-patient-assessment.identifying-persons")}
                  </ByzMuiTypography>
                  <ByzGrdDeleteButton
                      onClick={() => console.log(`Siliniyor`)} />
                </Grid>

                <Grid container spacing={2} paddingTop={"11px"}>
                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.degree-of-relationship")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={relationshipOptions}
                        label="label"
                        placeholder={t("open-process-menu.select")}
                        sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                        multiple = {false}
                      /> 
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.person-status")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={personStatusOptions}
                        label="label"
                        placeholder={t("open-process-menu.select")}
                        sx={{ width: "100%", maxWidth: "300px", pt: 1 }}
                        multiple = {false}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.name")}
                    >
                      <ByzMuiTextField
                        sx={{
                          width: "100%",
                          maxWidth: "300px",
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.surname")}
                    >
                      <ByzMuiTextField
                        sx={{
                          width: "100%",
                          maxWidth: "300px",
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.mobile-phone")}
                    >
                      <ByzMuiTextField
                        sx={{
                          width: "100%",
                          maxWidth: "300px",
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.work-phone")}
                    >
                      <ByzMuiTextField
                        sx={{
                          width: "100%",
                          maxWidth: "300px",
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={4} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.home-phone")}
                    >
                      <ByzMuiTextField
                        sx={{
                          width: "100%",
                          maxWidth: "300px",
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Grid
            md={12}
            xs={12}
            container
            direction={"row"}
            spacing={2}
            sx={{ padding: "0px", paddingTop: "20px", margin: "0px" }}
          >
            <Grid
              md={4}
              xs={12}
              spacing={2}
              sx={{ padding: "0px", paddingRight: "20px" }}
            >
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: "4px",
                  padding: "20px",
                }}
              >
                <Grid
                  sx={{
                    backgroundColor: "#63B4FF33",
                    color: "#2979C3",
                    borderRadius: "10px",
                  }}
                >
                  <ByzMuiTypography
                    isTitle
                    paddingRight={"20px"}
                    paddingTop={"5px"}
                  >
                    {t("newborn-patient-assessment.basic-safety-measures")}
                  </ByzMuiTypography>
                </Grid>
                <Stack direction={"column"} sx={{ paddingTop: "20px" }}>
                  <Stack direction={"row"} sx={{ paddingTop: "10px" }}>
                    <ByzMuiCheckBox />
                    <ByzMuiTypography
                      fontWeight={"400"}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {t("newborn-patient-assessment.service-introduced-to-patient")}
                    </ByzMuiTypography>
                  </Stack>
                  <Stack direction={"row"} sx={{ paddingTop: "10px" }}>
                    <ByzMuiCheckBox />
                    <ByzMuiTypography
                      fontWeight={"400"}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {t("newborn-patient-assessment.bed-rails-up")}
                    </ByzMuiTypography>
                  </Stack>
                  <Stack direction={"row"} sx={{ paddingTop: "10px" }}>
                    <ByzMuiCheckBox />
                    <ByzMuiTypography
                      fontWeight={"400"}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {t("newborn-patient-assessment.room-introduced-to-patient")}
                    </ByzMuiTypography>
                  </Stack>
                  <Stack direction={"row"} sx={{ paddingTop: "10px" }}>
                    <ByzMuiCheckBox />
                    <ByzMuiTypography
                      fontWeight={"400"}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {t("newborn-patient-assessment.bedside-arrangement-completed")}
                    </ByzMuiTypography>
                  </Stack>
                </Stack>
              </Box>
            </Grid>
            <Grid
              md={3}
              xs={12}
              spacing={2}
              sx={{ padding: "0px", paddingRight: "20px" }}
            >
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: "4px",
                  padding: "20px",
                }}
              >
                <Grid
                  sx={{
                    backgroundColor: "#63B4FF33",
                    color: "#2979C3",
                    borderRadius: "10px",
                  }}
                >
                  <ByzMuiTypography
                    isTitle
                    paddingRight={"20px"}
                    paddingTop={"5px"}
                  >
                    {t("newborn-patient-assessment.wristband")}
                  </ByzMuiTypography>
                </Grid>
                <ByzMuiRadioButton
                  typographyText="newborn-patient-assessment.exists-check-info,newborn-patient-assessment.not-present-ensure-attachment"
                  layout="column"
                  border="none"
                  fontSize={16}
                  textAlign="left"
                  maxWidth="100%"
                  defaultValue={["Var(Bilgileri Kontrol Ediniz", "Yok(Takılmasını Sağlayınız)"]}
                />
              </Box>
            </Grid>
            <Grid
              md={5}
              xs={12}
              spacing={2}
              sx={{ padding: "0px" }}
              direction={"row"}
            >
              <Stack direction={"row"}>
                <Grid
                  md={6}
                  xs={6}
                  sx={{ padding: "0px", paddingRight: "20px" }}
                >
                  <Box
                    sx={{
                      border: "1px solid #DBDBDB",
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Grid
                      sx={{
                        backgroundColor: "#63B4FF33",
                        color: "#2979C3",
                        borderRadius: "10px",
                      }}
                    >
                      <ByzMuiTypography
                        isTitle
                        paddingRight={"20px"}
                        paddingTop={"5px"}
                      >
                        {t("newborn-patient-assessment.oxygen-system")}
                      </ByzMuiTypography>
                    </Grid>
                    <ByzMuiRadioButton
                      typographyText="newborn-patient-assessment.open,newborn-patient-assessment.close"
                      layout="row"
                      border="none"
                      fontSize={16}
                    />
                  </Box>
                </Grid>
                <Grid md={6} xs={6} sx={{ padding: "0px" }}>
                  <Box
                    sx={{
                      border: "1px solid #DBDBDB",
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Grid
                      sx={{
                        backgroundColor: "#63B4FF33",
                        color: "#2979C3",
                        borderRadius: "10px",
                      }}
                    >
                      <ByzMuiTypography
                        isTitle
                        paddingRight={"20px"}
                        paddingTop={"5px"}
                      >
                        {t("newborn-patient-assessment.windows")}
                      </ByzMuiTypography>
                    </Grid>
                    <ByzMuiRadioButton
                      typographyText="newborn-patient-assessment.open,newborn-patient-assessment.close"
                      layout="row"
                      border="none"
                      fontSize={16}
                    />
                  </Box>
                </Grid>
              </Stack>
              <Stack direction={"row"}>
                <Grid
                  md={6}
                  xs={6}
                  sx={{
                    padding: "0px",
                    paddingRight: "20px",
                    paddingTop: "20px",
                  }}
                >
                  <Box
                    sx={{
                      border: "1px solid #DBDBDB",
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Grid
                      sx={{
                        backgroundColor: "#63B4FF33",
                        color: "#2979C3",
                        borderRadius: "10px",
                      }}
                    >
                      <ByzMuiTypography
                        isTitle
                        paddingRight={"20px"}
                        paddingTop={"5px"}
                      >
                        {t("newborn-patient-assessment.bed-brake")}
                      </ByzMuiTypography>
                    </Grid>
                    <ByzMuiRadioButton
                      typographyText="newborn-patient-assessment.open,newborn-patient-assessment.close"
                      layout="row"
                      border="none"
                      fontSize={16}
                    />
                  </Box>
                </Grid>
                <Grid md={6} xs={6} sx={{ padding: "0px", paddingTop: "20px" }}>
                  <Box
                    sx={{
                      border: "1px solid #DBDBDB",
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Grid
                      sx={{
                        backgroundColor: "#63B4FF33",
                        color: "#2979C3",
                        borderRadius: "10px",
                      }}
                    >
                      <ByzMuiTypography
                        isTitle
                        paddingRight={"20px"}
                        paddingTop={"5px"}
                      >
                        {t("newborn-patient-assessment.companion-requirement")}
                      </ByzMuiTypography>
                    </Grid>
                    <ByzMuiRadioButton
                      typographyText="newborn-patient-assessment.exists,newborn-patient-assessment.not-exists"
                      layout="row"
                      border="none"
                      fontSize={16}
                      sx={{ paddingTop: "20px" }}
                    />
                  </Box>
                </Grid>
              </Stack>
            </Grid>
          </Grid>
          <Grid
            md={12}
            xs={12}
            container
            direction={"row"}
            spacing={2}
            sx={{ padding: "0px", paddingTop: "20px", margin: "0px" }}
          >
            <Box
              sx={{
                border: "1px solid #DBDBDB",
                borderRadius: "4px",
                padding: "20px",
                width: "100%",
              }}
            >
              <Grid
                sx={{
                  backgroundColor: "#63B4FF33",
                  color: "#2979C3",
                  borderRadius: "10px",
                }}
              >
                <ByzMuiTypography
                  isTitle
                  paddingRight={"20px"}
                  paddingTop={"5px"}
                >
                  {t("newborn-patient-assessment.patient-info")}
                </ByzMuiTypography>
              </Grid>
              <Grid container spacing={2} pt={1}>
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.mother-full-name")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.mother-identity-number")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.father-full-name")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.father-identity-number")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.mother-education-level")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={educationOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>

              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />

              <Grid container spacing={2} alignItems={"top"}>
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                    title={t("newborn-patient-assessment.father-education-level")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={educationOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                    title={t("newborn-patient-assessment.mother-occupation")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={[]}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                    title={t("newborn-patient-assessment.father-occupation")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={[]}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.mother-habits")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={motherHabitsOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {true}
                    />

                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>

              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />

              <Grid container spacing={2} >
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.height-cm")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>

                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.weight-kg")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.temperature-c")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.pulse-per-minute")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.spo2-percent")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
 
              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />
 
              <Grid container spacing={2} >
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.respiration-per-minute")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.blood-pressure-mmhg")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.pain")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.birth-weight-under-one-year")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.head-circumference-baby")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
 
              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />
 
              <Grid container spacing={2} >
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.referral-location")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={referralLocationOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
 
                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.unit-arrival-method")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={arrivalMethodOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
 
                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                    title={t("newborn-patient-assessment.pregnancy-type")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={pregnancyTypeOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                    title={t("newborn-patient-assessment.reduction")}
                  >
                    <ByzMuiRadioButton
                      typographyText="yes,no,unknown"
                      layout="row"
                      border="none"
                      fontSize={16}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.multiple-pregnancy")}
                  >
                    <ByzMuiRadioButton
                      typographyText="yes,no,unknown"
                      layout="row"
                      border="none"
                      fontSize={16}
                    />
 
                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
 
              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />
 
              <Grid container spacing={2}>
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.number-of-pregnancies")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.number-of-births")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.number-of-miscarriages")}
                  >
                    <ByzMuiTextField
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.number-of-living-children")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.other")}
                  >
                    <ByzMuiTextField
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
 
              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />
 
              <Grid container spacing={2}>
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.admission-practices")}
                  >
                    <ByzMuiSelect
                      renderInput={(params) => (
                        <ByzMuiTextField {...params} />
                      )}
                      options={admissionPracticesOptions}
                      label="label"
                      placeholder={t(
                        "open-process-menu.select"
                      )}
                      sx={{ pt: 1 }}
                      multiple = {false}
                    />
 
                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.medication-during-pregnancy")}
                  >
                    <ByzMuiRadioButton
                      typographyText="yes,no,unknown"
                      layout="row"
                      border="none"
                      fontSize={14}
                    />
 
                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px"
                    title={t("newborn-patient-assessment.problems-during-pregnancy")}
                  >
                    <ByzMuiRadioButton
                      typographyText="yes,no,unknown"
                      layout="row"
                      border="none"
                      fontSize={14}
                    /> 
 
                    <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px", display: "flex", alignItems: "bottom", 
                      justifyContent: "flex-end" }}
                      title={t("description")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                    title=""
                  >
                    <Grid container md={12} xs={6} alignItems={"center"}>
                      <Grid
                        md={2}
                        display="flex"
                        flexDirection="column"
                      >
                        <ByzMuiCheckBox />
                      </Grid>
                      <Grid md={10}>
                        <ByzMuiTypography marginLeft="0px">
                          {t("newborn-patient-assessment.religious-and-cultural-needs")}
                        </ByzMuiTypography>
                      </Grid>
                    </Grid>
 
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                      title=""
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={3} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                    title=""
                  >
                    <Grid container md={12} xs={6} alignItems={"center"}>
                      <Grid
                        md={2}
                        display="flex"
                        flexDirection="column"
                      >
                        <ByzMuiCheckBox />
                      </Grid>
                      <Grid md={10}>
                        <ByzMuiTypography marginLeft="0px">
                          {t("newborn-patient-assessment.privacy-request")}
                        </ByzMuiTypography>
                      </Grid>
                    </Grid>
 
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                      title=""
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
 
              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />
 
              <Grid container spacing={2}>
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                    title=""
                  >
                    <Grid container md={12} xs={6} alignItems={"center"}>
                      <Grid
                        md={2}
                        display="flex"
                        flexDirection="column"
                      >
                        <ByzMuiCheckBox />
                      </Grid>
                      <Grid md={10}>
                        <ByzMuiTypography marginLeft="0px">
                          {t("newborn-patient-assessment.special-covering-preference")}
                        </ByzMuiTypography>
                      </Grid>
                    </Grid>
 
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                      title=""
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
 
                <Grid md={2} xs={6}>
                  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                    title=""
                  >
                    <Grid container md={12} xs={6} alignItems={"center"}>
                      <Grid
                        md={2}
                        display="flex"
                        flexDirection="column"
                      >
                        <ByzMuiCheckBox />
                      </Grid>
                      <Grid md={10} >
                        <ByzMuiTypography marginLeft="0px">
                          {t("newborn-patient-assessment.special-dressing-preference")}
                        </ByzMuiTypography>
                      </Grid>
                    </Grid>
 
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{ marginTop: "8px" }}
                      title=""
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </ByzTitleAndInputBox>
                </Grid>
              </Grid>
 
              <Divider
                sx={{
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  my: 2,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
 }
 
 export default PageOne;